<template>
  <div style="z-index: 2" id="foliomap" ref="foliomap" :style="{ height: height + 'px', minHeight: '400px' }" />
</template>

<script>
import 'leaflet/dist/leaflet.css'
import { FolioLeaf } from '@/my-leaf/charts/folio-leaf'
import { mapStores } from 'pinia'
import { useCatalogsStore } from '@/stores/catalogs'
import { useDeviceStore } from '@/stores/device'
import { useFleetStore } from '@/stores/fleet'

export default {
  name: 'FolioMap',
  props: ['height'],
  data() {
    return {
      foliomap: new FolioLeaf(),
    }
  },
  methods: {
    showFolioCell(cellName) {
      this.foliomap.highlightCell(cellName)
    },
    drawShipPosition() {
      // Получаем позицию выбранного корабля из флот стора
      const shipPosition = this.fleetStore.selectedShipPosition
      if (shipPosition && shipPosition.lat && shipPosition.lon) {
        this.foliomap.drawShipMarker(shipPosition)
      }
    },
    async init_map() {
      try {
        // Передаем ссылку на стор для работы с продуктами в FolioLeaf
        this.foliomap.catalogsStore = this.catalogsStore;

        // Ждем асинхронную инициализацию карты
        await this.foliomap.init(this.$refs.foliomap);

        const allCharts = this.catalogsStore.getItems;
        const purchasedList = this.deviceStore.orderedData.primar.enc;
        const purchasedIds = purchasedList.map(item => item.name);

        // Фильтрация только приобретённых ячеек
        const purchasedCharts = allCharts.filter(chart => {
          return purchasedIds.includes(chart.id);
        });

        this.foliomap.showRoute();
        this.foliomap.drawAllCells(purchasedCharts);
        
        // Отображаем позицию корабля на карте (без центрирования)
        this.drawShipPosition();
        
        return Promise.resolve();
      } catch (error) {
        console.error('FolioMap: error initializing map:', error);
        return Promise.reject(error);
      }
    },
  },

  computed: {
    ...mapStores(useDeviceStore, useCatalogsStore, useFleetStore),
  },

  watch: {
    // Ворчер для обновления ячеек на карте при изменении данных в сторе
    'deviceStore.orderedData.primar.enc': {
      handler(newVal) {
        if (this.foliomap && this.foliomap.isInitialized) {
          console.log('FolioMap: orderedData changed, updating cells on map');
          const allCharts = this.catalogsStore.getItems;
          const purchasedIds = newVal.map(item => item.name);
          
          const purchasedCharts = allCharts.filter(chart => {
            return purchasedIds.includes(chart.id);
          });
          
          this.foliomap.drawAllCells(purchasedCharts);
        }
      },
      deep: true
    }
  },

  beforeDestroy() {
    // Очищаем Leaflet карту и освобождаем ресурсы
    if (this.foliomap) {
      try {
        // Use the destroy method for complete cleanup
        this.foliomap.destroy()
        this.foliomap = null

        console.log('FolioMap: map and resources cleaned up')
      } catch (error) {
        console.warn('FolioMap: error cleaning up map', error)
      }
    }
  },
}
</script>

<style>
#foliomap {
  border: solid 1px dimgray;
}

.leaflet-interactive:hover {
  stroke: #ffa011;
  stroke-width: 4;
}

/* Стили для маркера корабля */
:deep(.ship-icon-container) {
  background: transparent;
  border: none;
}
</style>
